import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, PropsWithChildren, useState} from "react";
import {userLoginOIDC, getSessionAction} from "modules/actions";
import {SSOUtils} from "modules/utils/sso";
import {isAuthedSelector, getIsUserLoading} from "modules/selectors";
import {SSO_SYNDICATE} from "modules/constants";
import {PagePreloader} from "components/Preloader";

export const SSOProvider: React.FC<PropsWithChildren> = ({children}) => {
	const dispatch = useDispatch();
	const code = new URLSearchParams(window.location.search).get("code");
	const isAuthenticated = useSelector(isAuthedSelector);
	const isUserLoading = useSelector(getIsUserLoading);
	const [isSessionChecked, setIsSessionChecked] = useState(false);

	useEffect(() => {
		dispatch(
			getSessionAction({
				callback: () => {
					setIsSessionChecked(true);
				},
			})
		);
	}, [dispatch]);

	useEffect(() => {
		if (!code || isAuthenticated || !isSessionChecked) {
			return;
		}

		const paramsWithoutCode = new URLSearchParams(window.location.search);
		paramsWithoutCode.delete("code");
		const searchString = paramsWithoutCode.toString().length ? "?" + paramsWithoutCode.toString() : "";
		window.history.replaceState(null, "", window.location.pathname + searchString);

		dispatch(
			userLoginOIDC({
				code,
				redirect_uri: SSOUtils.REDIRECT_URL,
				syndicate: SSO_SYNDICATE,
			})
		);
	}, [dispatch, code, isAuthenticated, isSessionChecked]);

	if (!isSessionChecked || isUserLoading) {
		return <PagePreloader />;
	}

	return <div>{children}</div>;
};
